module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"uploader.upload.label":"Upload","uploader.error.invalid_type":"ไม่รองรับ File ประเภทนี้ {type}","uploader.error.exceed_size":"File มีขนาดเกินกว่า {max}"}}')
  delete Component.options._Ctor
}
